module.exports = __webpack_public_path__ + "img/marker.f070d53c.gif";